export default __webpack_public_path__ + "static/media/2387.30961f6d.png";